module.exports = __webpack_public_path__ + "img/titulo-dorso-2.9e8469e4.png";